export { default as TermPaymentMethod } from './term-payment-method';
export * from './term-payment-utils';
export * from './term-payment-method.styles';
